module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AlJ4I/tc-custom/9781633410244.jpg?1726617370023",
      "alt": "This image is the cover for the book Find Your Soul's Purpose"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Find Your Soul's Purpose\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Discover your divine purpose and live the life you were meant to live with this inspirational and deeply spiritual guide.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Who am I? Why am I here? What is my purpose? These are questions we have all asked ourselves at some point in our lives. Though we know ourselves best, it can be difficult to separate who we are from who we want to be or how others see us. We present so many different versions of ourselves to the world that our true identity can get lost in the process."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Maybe you’ve been on a steady path for a while, and you’re only now beginning to question if you’ve been heading in the right direction. Maybe you’ve wandered all your life with no direction at all. Either way, writer and spiritual guide Janet Conner offers the tools to reconnect with ourselves and the divine purpose affixed to our souls."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Read "), _c('i', [_vm._v("Find Your Soul’s Purpose")]), _vm._v(" and discover: An inspirational and spiritual book with a soul-community creator as your guideRenewal of meaning in your day-to-day lifeA journey to finding yourself and your divine purpose\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Janet Conner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Conari Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0